import {
	PRODUCT_BOX_ADDON_ID,
	PRODUCT_PLAYER_ID,
	PRODUCT_SOUNDREEF_ADDON_ID,
} from '@/core/api/entities/misc/product'

import { Subscription } from './subscription'

export class StatusUpgrade {
	public availableLicenses: number
	public availableSubscriptions: number
	public validBillingDate: boolean
	public hasBoxes: boolean
	public hasZones: boolean
	public hasBilling: boolean
	public boxMode: string | null
	public subscriptions: Subscription[]
	public allSubscriptions: Subscription[]

	constructor(data: {
		availableLicenses: number
		availableSubscriptions: number
		validBillingDate: boolean
		hasBoxes: boolean
		hasZones: boolean
		hasBilling: boolean
		boxMode: string | null
		subscriptions: Subscription[]
		allSubscriptions: Subscription[]
	}) {
		this.availableLicenses = data.availableLicenses
		this.availableSubscriptions = data.availableSubscriptions
		this.validBillingDate = data.validBillingDate
		this.hasBoxes = data.hasBoxes
		this.hasZones = data.hasZones
		this.hasBilling = data.hasBilling
		this.boxMode = data.boxMode
		this.subscriptions = data.subscriptions
		this.allSubscriptions = data.allSubscriptions
	}

	static create(data: Partial<StatusUpgrade>): StatusUpgrade {
		const defaultData = {
			availableLicenses: 0,
			availableSubscriptions: 0,
			validBillingDate: false,
			hasBoxes: false,
			hasZones: false,
			hasBilling: false,
			boxMode: null,
			subscriptions: [],
			allSubscriptions: [],
		}

		return new StatusUpgrade({ ...defaultData, ...data })
	}

	// Return true if any new product will update the subscription
	get willUpdateSubscription(): boolean {
		return this.availableLicenses <= 0
	}

	// Return true if the account has a box mode defined
	get hasBoxMode(): boolean {
		return !!this.boxMode
	}

	// Return true if the account is in one shot mode
	get isOneShotMode(): boolean {
		return this.boxMode === 'one_shot'
	}

	// Return the total quantity of the product received
	getTotalProduct(productId: number): number {
		let total = 0
		this.subscriptions?.forEach((subscription) => {
			total += subscription.getProductQuantity(productId) ?? 0
		})

		return total
	}

	// Return the total quantity of the player product
	getTotalZones(): number {
		return this.getTotalProduct(PRODUCT_PLAYER_ID)
	}

	// Return the total quantity of the box product
	getTotalBoxes(): number {
		return this.getTotalProduct(PRODUCT_BOX_ADDON_ID)
	}

	// Return the total quantity of the soundreef product
	getTotalLicenses(): number {
		return this.getTotalProduct(PRODUCT_SOUNDREEF_ADDON_ID)
	}
}
